import {NgModule} from '@angular/core';
import {UpgradeModule} from '@angular/upgrade/static';
import {MyTimeModule} from '../my-time/my-time.module';
import {employeeEditHistoryResourceFactory, SettingsModule} from '../settings/settings.module';
import {ApiModule} from '../api/api.module';
import {CookieModule} from 'ngx-cookie';
import {ReportsModule} from '../reports/reports.module';
import {EmployeesEditHistoryCacheService} from './employee-edit-history-cache.service';
import {AdminLoginPanelComponent} from './components/admin-login-panel.component';
import {CommonModule} from '@angular/common';
import {GlobalNotificationsComponent} from './components/global-notifications/global-notifications.component';
import {GlobalNotificationsService} from './components/global-notifications/global-notifications.service';
import {ApiConfigService} from './api-config.service';

@NgModule({
	declarations: [
		AdminLoginPanelComponent,
		GlobalNotificationsComponent
	],
	providers: [
		EmployeesEditHistoryCacheService,
		{
			provide: 'EmployeeEditHistoryResource',
			useFactory: employeeEditHistoryResourceFactory,
			deps: []
		},
		GlobalNotificationsService,
		ApiConfigService
	],
	imports: [
		CommonModule,
		UpgradeModule,
		CookieModule.forRoot(),
		MyTimeModule,
		SettingsModule,
		ApiModule,
		ReportsModule
	],
	exports: [GlobalNotificationsComponent],
	entryComponents: [
		AdminLoginPanelComponent,
		GlobalNotificationsComponent
	]
})
export class CoreModule {}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts